import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const LanguageAndCommunication = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="96" viewBox="0 0 91 96" width="91" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M69.82 15.35v42.1a2.65 2.65 0 0 1-2.65 2.65H61.4c-.9 0-1.73.46-2.22 1.21L49.4 76.35a2.66 2.66 0 0 1-4.46 0l-9.79-15.04a2.7 2.7 0 0 0-2.22-1.2H14.05a2.65 2.65 0 0 1-2.65-2.66v-42.1a2.65 2.65 0 0 1 2.65-2.65h53.13a2.65 2.65 0 0 1 2.65 2.65z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M65.21 9.77v42.1a2.65 2.65 0 0 1-2.65 2.65h-5.75c-.9 0-1.74.46-2.23 1.21L44.8 70.77a2.66 2.66 0 0 1-4.46 0l-9.79-15.04a2.7 2.7 0 0 0-2.22-1.2H9.43a2.65 2.65 0 0 1-2.64-2.65V9.77a2.65 2.65 0 0 1 2.65-2.65h53.12a2.65 2.65 0 0 1 2.65 2.65Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M83.5 26.27v42.1a2.65 2.65 0 0 1-2.65 2.66H68.6c-.9 0-1.73.45-2.22 1.2L56.6 87.27a2.66 2.66 0 0 1-4.46 0l-9.79-15.04a2.7 2.7 0 0 0-2.22-1.2H27.88a2.65 2.65 0 0 1-2.65-2.65V26.27a2.65 2.65 0 0 1 2.65-2.65h53a2.65 2.65 0 0 1 2.64 2.65z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M78.89 20.68v42.1a2.65 2.65 0 0 1-2.65 2.66H63.99c-.9 0-1.74.45-2.23 1.2L51.98 81.7a2.66 2.66 0 0 1-4.46 0l-9.79-15.05a2.7 2.7 0 0 0-2.22-1.2H23.26a2.65 2.65 0 0 1-2.65-2.65V20.7a2.65 2.65 0 0 1 2.65-2.66h53a2.65 2.65 0 0 1 2.64 2.65z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="M58.96 37.26v12.29H52.8V43.4h-6.14v6.14h-6.15V37.26z" fill={shades.black} />
    </svg>
  );
};
